import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { StorylineDilemmaOption } from '../../Types/StorylineDilemma';
import AttributeCard from './AttributeCard';

interface StorylineDilemmaAttributeOptionCardProps {
  option: StorylineDilemmaOption;
  isSelected: boolean;
  onClick: (option: StorylineDilemmaOption) => void;
  disabled?: boolean;
}

export const StorylineDilemmaAttributeOptionCard: React.FC<
  StorylineDilemmaAttributeOptionCardProps
> = ({ option, isSelected, onClick, disabled = false }) => {
  if (!option.attribute) {
    throw new Error('Attribute option must have an attribute');
  }

  return (
    <button
      type="button"
      data-testid={`storyline-dilemma-attribute-option-card`}
      className="max-md:mt-3 max-lg:mt-0 w-full sm:grow relative"
      onClick={() => onClick(option)}
      disabled={disabled}
    >
      {isSelected && (
        <>
          <div className="absolute right-2.5 top-2.5 bg-blue-600 rounded-full w-10 h-10 flex justify-center items-center z-10">
            <FontAwesomeIcon icon={faCheck} color={'white'} />
          </div>
          <div className="absolute inset-0 rounded-xl shadow-[0_0_0_8px_rgba(37,99,235)_inset] z-10"></div>
        </>
      )}
      <AttributeCard attribute={option.attribute} isSelected={isSelected} />
    </button>
  );
};
